import type { EntryValueViewT } from "@patient-watch/types";

function isBareCode(text: string, numberValue: number | null | undefined): boolean {
    if (numberValue != null && text === String(numberValue)) return true;
    return /^-?[0-9]+(\.[0-9]+)?$/.test(text);
}

/** Dictionary / single-choice label. Prefer the linked option, never a bare code when a label exists. */
export function choiceEntryValueLabel(
    ev: Pick<EntryValueViewT, "text_value" | "number_value" | "value" | "options">
): string {
    const options = ev.options ?? [];
    const linkedLabel = options.find((option) => option.label?.trim())?.label?.trim();
    if (linkedLabel) return linkedLabel;

    const text = ev.text_value?.trim();
    if (text && !isBareCode(text, ev.number_value)) return text;

    const code = text ?? (ev.number_value != null ? String(ev.number_value) : null);
    const matched = options.find((option) => String(option.value ?? "") === code);
    if (matched?.label?.trim()) return matched.label.trim();

    if (text) return text;
    if (ev.number_value != null) return String(ev.number_value);
    if (ev.value != null && ev.value !== "") return String(ev.value);
    return "N/A";
}
